import React from 'react'
import styled from 'styled-components'

const Container = styled.div`
  .c-wrap {
    max-width: 1280px;
    margin: auto;
    padding: 0 24px;
  }

  .c-lay {
    display: table;
    width: 100%;
  }

  .c-lay-main {
    display: table-cell;
    vertical-align: top;
    text-align: left;
  }

  li {
    font-size: 14px;
  }

  .c-lay-main .main-title,
  .c-lay-main h2 {
    font-family: inherit;
  }

  .c-lay-main .main-title {
    display: block;
    padding: 60px 0 12px 0;
    margin: 0 0 40px 0;
    font-size: 22px;
    font-weight: bold;
    text-transform: uppercase;
    color: #262626;
  }

  .main-title {
    display: inline;
    font-size: 22px;
    text-align: center;
  }

  .c-lay-main .main-title:after {
    display: block;
    content: '';
    margin: 12px auto 0 auto;
    height: 1px;
    width: 70px;
    background-color: #262626;
  }

  .c-lay-main h2 {
    padding: 16px 0 6px 0;
    font-size: 14px;
    color: #494949;
  }

  .c-lay-main p {
    font-size: 14px;
    color: #494949;
    text-align: justify;
  }

  .c-lay-main p:last-child {
    padding-bottom: 60px;
  }

  .c-lay-main p.c-plist {
    padding-left: 14px;
  }

  .c-lay-main p.u-center {
    text-align: center;
  }

  .c-lay-main p.u-bold {
    font-weight: 600;
  }

  .c-lay-main p,
  .c-lay-main li {
    overflow-wrap: break-word;
    word-wrap: break-word;
    -ms-word-break: break-all;
    word-break: break-all;
    word-break: break-word;
    -ms-hyphens: auto;
    -moz-hyphens: auto;
    -webkit-hyphens: auto;
    hyphens: auto;
  }

  .c-lay-main a {
    word-break: break-all;
    color: #4767f2;
    font-size: 14px;
    text-decoration: none;

    &:hover {
      color: #e00034;
      text-decoration: underline;
    }
  }
`

const GroupWebsites = () => (
  <Container>
    <div className="c-wrap">
      <div className="c-lay">
        <div className="c-lay-main">
          <h1 className="u-center main-title">À propos du Groupe SeLoger</h1>
          <p>
            Le Groupe SeLoger est le groupe leader spécialiste des portails immobiliers en France. Notre mission est d’offrir à chacun de nos utilisateurs une expérience
            immobilière simple et efficace afin qu’ils concrétisent leurs projets d’achat, de vente ou de location en toute sérénité.
            <br />
            Notre ambition est de proposer sur nos sites et applications spécialistes une expérience personnalisée adaptée aux besoins de chacun.
          </p>
          <p>La liste de ces sites et applications spécialisés se trouve ci-dessous.</p>
          <strong>Nos plateformes</strong>

          <h2>L’ancien</h2>
          <ul>
            <li>
              <a href="http://seloger.com">SeLoger</a>
            </li>
            <li>
              <a href="http://logic-immo.com">Logic-Immo</a>
            </li>
            <li>
              <a href="https://edito.seloger.com/">Édito SeLoger</a>
            </li>
            <li>
              <a href="https://blog.logic-immo.com/">Édito Logic-Immo</a>
            </li>
            <li>L’application SeLoger</li>
            <li>L’application Logic-Immo</li>
          </ul>

          <h2>Le neuf</h2>
          <ul>
            <li>
              <a href="http://Selogerneuf.com">SeLoger neuf</a>
            </li>
            <li>
              <a href="https://neuf.logic-immo.com/">Logic-Immo neuf</a>
            </li>
            <li>L’application SeLoger neuf</li>
            <li>
              <a href="https://edito.selogerneuf.com/">Edito SeLoger neuf</a>
            </li>
          </ul>

          <h2>La construction</h2>
          <ul>
            <li>
              <a href="https://www.seloger-construire.com">SeLoger construire</a>
            </li>
            <li>
              <a href="https://construire.logic-immo.com/">Logic-Immo Faire construire</a>
            </li>
            <li>
              <a href="http://actualite.seloger-construire.com">Actualités SeLoger construire</a>
            </li>
          </ul>

          <h2>L’immobilier de luxe</h2>
          <ul>
            <li>
              <a href="https://www.bellesdemeures.com/">Belles Demeures</a>
            </li>
            <li>
              <a href="https://www.lux-residence.com">Lux Residence</a>
            </li>
            <li>
              <a href="https://magazine.bellesdemeures.com/">Magazine Belles Demeures</a>
            </li>
            <li>L’application Belles Demeures</li>
          </ul>

          <h2>L’immobilier d’entreprise</h2>
          <ul>
            <li>
              <a href="https://www.seloger-bureaux-commerces.com/achat/fonds-de-commerce">SeLoger Bureaux et Commerces</a>
            </li>
            <li>
              <a href="http://pro-bureaux-commerces.seloger.com/espace-professionnel">SeLoger Bureaux et Commerces PAUnit</a>
            </li>
            <li>
              <a href="https://actualites.seloger-bureaux-commerces.com/">Actualités Bureaux et Commerces</a>
            </li>
          </ul>

          <h2>La location saisonnière</h2>
          <ul>
            <li>
              <a href="https://vacances.com/">Vacances.com</a>
            </li>
            <li>
              <a href="https://www.amivac.com/">Amivac</a>
            </li>
            <li>
              <a href="https://vacances.seloger.com/">SeLoger Vacances</a>
            </li>
            <li>
              <a href="http://malocationsaisonniere.com/">Ma location saisonnière</a>
            </li>
          </ul>

          <h2>Les sites dédiés aux professionnels</h2>
          <ul>
            <li>
              <a href="https://myselogerpro.com/login">my SeLoger pro</a>
            </li>
            <li>Application my SeLoger pro</li>
            <li>
              <a href="http://myselogerpro.logicimmopro.com">Logic-Immo pro</a>
            </li>
            <li>Tags Pub SeLoger</li>
            <li>
              <a href="https://www.myadfactory.digital/">My AdFactory</a>
            </li>
            <li>
              <a href="http://www.groupeseloger.com/">Groupeseloger.com</a>
            </li>
            <li>
              <a href="https://regie.seloger.com/">regie.seloger.com</a>
            </li>
            <li>
              <a href="https://presse.groupe-seloger.com/">presse.groupe-seloger.com/</a>
            </li>
          </ul>

          <h2>Autre</h2>
          <ul>
            <li>
              <a href="https://www.lacoteimmo.com/">La Cote Immo</a>
            </li>
          </ul>

          <p className="u-bold">
            Le Groupe SeLoger (Digital Classifieds France) édite l’ensemble des sites et applications référencés ci-dessus, en tant que Responsable de Traitement au sens du
            Règlement UE 2016/679 du Parlement Européen et du Conseil du 27 avril 2016 dit “RGPD” .
            <br />
            Votre choix relatif aux traceurs et cookies (consentement ou refus), via la fenêtre de paramétrage de l’un de ces sites ou applications, est valable pour l’ensemble des
            sites et applications référencés ci-dessus.
          </p>
        </div>
      </div>
    </div>
  </Container>
)

export default GroupWebsites
